import { PageLayout } from '@/components/PageLayout';
import { Seo } from '@/components/Seo';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { ROUTES } from '@/constants/site';
import { HeroSection } from './sections/HeroSection';
import { BrandIntroSection } from './sections/BrandIntroSection';
import { ProductLineupSection } from './sections/ProductLineupSection';
import { WorkflowSection } from './sections/WorkflowSection';
import { CustomDashboardSection } from './sections/CustomDashboardSection';
import { NovaAiSection } from './sections/NovaAiSection';
import { AutomationSection } from './sections/AutomationSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { InquiryCtaSection, PlanCtaSection } from './sections/CtaSections';

const DESCRIPTION =
  'Nova는 수집·파싱·저장·분석·인텔리전스·협업까지 하나의 플랫폼에서 완결하는 AI 기반 DFIR 플랫폼입니다.';

export default function IndexPage() {
  useScrollReveal();

  return (
    <>
      <Seo
        title="Nova"
        ogTitle="Nova — 골든타임 안에 완결하는 AI 기반 DFIR 플랫폼"
        description={DESCRIPTION}
        path={ROUTES.index}
      />
      <PageLayout bodyClass="page-index">
        <HeroSection />
        <BrandIntroSection />
        <ProductLineupSection />
        <WorkflowSection />
        <CustomDashboardSection />
        <NovaAiSection />
        <AutomationSection />
        <FeaturesSection />
        <PlanCtaSection />
        <InquiryCtaSection />
      </PageLayout>
    </>
  );
}
